<template>
    <VerifyPhoneDialogs v-if="isUserPendingSMS" :phoneNumberInput="phoneNumberInput" />
</template>



<script>

import { computed, provide, ref, watch } from "vue";
import { useAuthStore } from "../../store/AuthStore";
import { useUserStore } from "../../store/UserStore";
import { UserActivityStore } from "@/store/UserActivityStore";
import VerifyPhoneDialogs from "@/components/PhoneVerification/Verify-Phone-Dialogs.vue";

import { PHONE_NUMBER_STATUS } from '@/constants/PhoneNumberStatus';
import { PHONE_NUMBER_VERIFICATION_STEPS } from '@/constants/PhoneNumberVerificationSteps';

export default {
    name: "PhoneVerification",
    components: {
        VerifyPhoneDialogs,
    },
    setup() {
        const authStore = useAuthStore();
        const userStore = useUserStore();
		// authStore.initialize(); TODO: check this later

		const userActivityStore = UserActivityStore();
        let openDialogForOTPVerification = ref(false);

        const phoneNumberInput = computed(() => {
            return {
                phone_number: userStore.user.phone_number,
                phone_country_code: userStore.user.phone_country_code,
                phone_iso_code: userStore.user.phone_iso_code,
            }
        });

        const isErrorCode230 = computed(() => authStore.failureResponse.response?.data?.error?.code === 230);
        const selectedInHouseTask = computed(() => userActivityStore.selectedInHouseTask.name === "Verify Your Phone");

        const isUserPendingSMS = computed(() => userStore.user.verification_status === PHONE_NUMBER_STATUS.PENDING_SMS);

        watch(phoneNumberInput, (newVal) => {
            if (newVal) {
                if (!selectedInHouseTask.value && isUserPendingSMS.value)
                    openDialogForOTPVerification.value = true;
            }
        });

        watch(() => authStore.failureResponse, (newVal) => {
            if (isErrorCode230.value) {
                openDialogForOTPVerification.value = true;
            }
        },
            { deep: true }
        );

        provide('openForOTPResend', openDialogForOTPVerification);
		return { PHONE_NUMBER_VERIFICATION_STEPS, isUserPendingSMS, phoneNumberInput };
    },
};
</script>